import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { listTypes } from '../constants.js';
import { isMobile } from './helpers/HelperFunctions.js';

export class SwiperControl extends Component {
    constructor(props) {
        super(props);

        const showArrows = props.showArrows && !isMobile();
        const modules = [];
        if (props.autoplay) {
            modules.push(Autoplay);
        }
        if (showArrows) {
            modules.push(Navigation);
        }
        else {
            modules.push(Pagination);
        }

        this.state = {
            modules: modules,
            showArrows: showArrows
        }
    }

    getBreakpoints() {
        switch (this.props.type) {
            case listTypes.News:
            case listTypes.Widgets:
                return {
                    768: {
                        slidesPerView: 2
                    },
                    1025: {
                        slidesPerView: 3
                    },
                    1401: {
                        slidesPerView: 4
                    }
                }
            default:
                return {
                    768: {
                        slidesPerView: 2
                    },
                    1025: {
                        slidesPerView: 3.2
                    },
                    1401: {
                        slidesPerView: 4.2
                    }
                }
        }
    }

    render() {
        const { modules } = this.state;

        return <div className="swiper">
            <Swiper
                spaceBetween={this.props.spaceBetween ?? 10}
                slidesPerView={1}
                breakpoints={this.getBreakpoints()}
                modules={modules}
                pagination={{
                    clickable: true,
                }}
                navigation={this.state.showArrows}
                watchOverflow={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                loop={this.props.type === listTypes.News}
            >
                {this.props.items.map((item, index) => <SwiperSlide key={index} >{() => <this.props.itemComponent item={item} />}</SwiperSlide>)}
            </Swiper>
        </div>
    }
}